import React from 'react';
import { DimensionTimeframeValues, KPILeaderboardState } from '../../_types';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  CustomSelect,
  CustomFilterContainer,
  CustomFilterTitle,
} from '../KPIFilter.styles';
import {
  getDimensionTimeframeTitle,
  getDimensionValues,
} from '../../_kpiLeaderboardHelpers';
import format from 'date-fns/format';

interface FilterDimensionValuesProps {
  kpiLeaderboardState: KPILeaderboardState;
  onChangeKpiLeaderboardState: (
    kpiLeaderboardState: KPILeaderboardState
  ) => void;
  resetTokens: () => void;
}

const FilterDimensionValues = ({
  kpiLeaderboardState,
  onChangeKpiLeaderboardState,
  resetTokens,
}: FilterDimensionValuesProps) => {
  if (kpiLeaderboardState.dimensionTimeframe === DimensionTimeframeValues.Day) {
    return (
      <CustomFilterContainer>
        <CustomFilterTitle>Day</CustomFilterTitle>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            PaperProps={{
              sx: {
                '& .MuiPickersDay-root': {
                  '&.Mui-selected': {
                    backgroundColor: '#5F27CD',
                  },
                },
              },
            }}
            InputProps={{
              sx: {
                borderRadius: '10px',
              },
            }}
            // NOTE: Needed for offset 4 hours because EDT is default timezone which results in settig to 4 hours before midnight which is the day before what is actually set
            value={
              new Date(kpiLeaderboardState.dimensionValue + 'T00:00:00-04:00')
            }
            onChange={(value) => {
              onChangeKpiLeaderboardState({
                ...kpiLeaderboardState,
                dimensionValue: format(value as Date, 'yyyy-MM-dd'),
                currentPage: 0,
              });
              resetTokens();
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  sx={{
                    '& input': { padding: '10px' },
                    '& fieldset': {
                      borderRadius: '10px !important',
                    },
                  }}
                />
              );
            }}
          />
        </LocalizationProvider>
      </CustomFilterContainer>
    );
  }

  return (
    <CustomFilterContainer>
      <CustomFilterTitle>
        {getDimensionTimeframeTitle(kpiLeaderboardState.dimensionTimeframe)}
      </CustomFilterTitle>
      <CustomSelect
        value={kpiLeaderboardState.dimensionValue}
        onChange={(e) => {
          onChangeKpiLeaderboardState({
            ...kpiLeaderboardState,
            dimensionValue: e.target.value,
            currentPage: 0,
          });
          resetTokens();
        }}
      >
        {getDimensionValues(kpiLeaderboardState.dimensionTimeframe).map(
          (dimensionValue) => {
            return (
              <option key={dimensionValue.value} value={dimensionValue.value}>
                {dimensionValue.label}
              </option>
            );
          }
        )}
      </CustomSelect>
    </CustomFilterContainer>
  );
};

export default FilterDimensionValues;
